<template>
  <div id="slider" class="">
    <div class="absolute left-0 z-20 flex items-center justify-center w-16 h-full bg-opacity-0 cursor-pointer text-default-200 md:w-24 hover:bg-opacity-25 bg-default-300" aria-label="Previous slide" @click="slide(-1)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" class="h-10 w-10">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/>
      </svg>
    </div>

    <div class="absolute right-0 z-20 flex items-center justify-center w-16 h-full bg-opacity-0 cursor-pointer text-default-200 md:w-24 hover:bg-opacity-25 bg-default-300" aria-label="Next slide" @click="slide(1)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" class="h-10 w-10">
        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/>
      </svg>
    </div>

    <transition-group
      tag="div"
      :name="transitionName"
      class="h-full slides-group"
    >
      <div
        v-if="show"
        :key="current"
        class="absolute top-0 h-full slide"
        :class="{ current }"
      >
        <a
          :href="itens[current].link"
          class="relative w-full h-full overflow-hidden text-default-500 hover:text-default-600"
          :title="itens[current].title"
        >
          <img
            :src="itens[current].img"
            class="object-contain w-full h-full md:object-cover"
            :class="{ 'object-cover': itens[current].description }"
            :alt="itens[current].title"
          />

          <h3
            v-if="itens[current].description"
            class="absolute bottom-0 z-10 w-full h-32 p-4 font-semibold bg-white md:px-8 md:text-xl"
          >
            {{ itens[current].description }}
          </h3>
        </a>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: ["itens"],

  data() {
    return {
      current: 0,
      direction: 1,
      transitionName: "fade",
      show: false,
      slides: [
        { className: "blue" },
        { className: "red" },
        { className: "yellow" },
      ],
    };
  },
  methods: {
    slide(dir) {
      this.direction = dir;
      dir === 1
        ? (this.transitionName = "slide-next")
        : (this.transitionName = "slide-prev");
      var len = this.itens.length;
      this.current = (this.current + (dir % len) + len) % len;
    },
  },
  mounted() {
    this.show = true;
    setInterval(() => this.slide(1), 8000);
  },
};
</script>

<style scoped>
img {
  max-width: 1920px;
}
/* FADE IN */
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter {
  opacity: 0;
}

/* GO TO NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-next-enter {
  transform: translate(100%);
}
.slide-next-leave-to {
  transform: translate(-100%);
}

/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-prev-enter {
  transform: translate(-100%);
}
.slide-prev-leave-to {
  transform: translate(100%);
}

/* SLIDES CLASSES */

.slide {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.description {
  background: rgba(0, 0, 0, 0.5);
}
</style>
